<!--  -->
<template>
  <div class="child-box" style="height:auto">
    <div class="child-head">
      <div class="child-name">视频监控</div>
    </div>
    <div class="content">
      <div class="content-box">
        <div class="content-item">
          <div class="video">
            <video ref="video1" src="../assets/videos/1.mp4" muted loop autoplay></video>
          </div>
          <div class="name">
            <div class="btn"></div>
            <div>监控1</div>
          </div>
        </div>
        <div class="content-item">
          <div class="video">
            <video ref="video2" src="../assets/videos/2.mp4" muted loop autoplay></video>
          </div>
          <div class="name">
            <div class="btn"></div>
            <div>监控2</div>
          </div>
        </div>
        <div class="content-item" >
          <div class="video">
            <video ref="video3" src="../assets/videos/3.mp4" muted loop autoplay></video>
          </div>
          <div class="name">
            <div class="btn"></div>
            <div>监控3</div>
          </div>
        </div>
        <div class="content-item" >
          <div class="video">
            <video ref="video4" src="../assets/videos/4.mp4" loop autoplay></video>
          </div>
          <div class="name">
            <div class="btn"></div>
            <div>监控4</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
     
    };
  },

  created() {},

  mounted() {
    
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.content {
  width: 261px;
  height: 21vh;
  background: url(../assets/videobg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 17px;
  margin-left: 15%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .content-box {
    width: 85%;
    margin-left: 7.5%;
    height: 96%;
    margin-top: 14px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    color: #fff;
    .content-item {
      width: 105px;
      height: 8.9vh;
      .video {
        width: 100%;
        height: 7.7vh;
        video {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        display: flex;
        font-size: 9px;
        justify-content: center;
        align-items: center;
        .btn {
          width: 5.71px;
          height: 5.71px;
          background: rgb(6, 106, 205);
          margin-right: 5px;
        }
        // &:after{
        //   content: '';
        //   width: 5.71px;
        //   height: 5.71px;
        //   background: rgb(6, 106, 205);
        //   position: absolute;
        // }
      }
      // background: red;
    }
  }
}
</style>>
